export const CONTACT_SUBMITTED_EVENT = "enkey:contact-submitted";

// No form contents or contact details are passed to advertising integrations.
export function notifyContactSubmitted() {
  window.dispatchEvent(new Event(CONTACT_SUBMITTED_EVENT));
}

export function listenForMetaContactConversion(options: {
  marketingConsent: boolean;
  pixelId?: string;
  privateArea: boolean;
}) {
  const pixelId = options.pixelId?.trim();
  if (!options.marketingConsent || options.privateArea || !pixelId || !/^\d{5,}$/.test(pixelId)) {
    return () => {};
  }
  const onSubmitted = () => {
    try {
      window.fbq?.("trackSingle", pixelId, "Lead");
    } catch {
      // An unavailable advertising service must never invalidate a saved request.
    }
  };
  window.addEventListener(CONTACT_SUBMITTED_EVENT, onSubmitted);
  return () => window.removeEventListener(CONTACT_SUBMITTED_EVENT, onSubmitted);
}
